import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { EMMAInputComponent } from '../emma-input.component';

@Component({
    selector: 'emma-rich-editor-insert-image-tag-modal',
    templateUrl: './emma-rich-editor-insert-image-tag-modal.component.html',
    standalone: false
})
export class EMMARichEditorInsertImageTagModalComponent implements AfterViewInit {
  @ViewChild('srcInput', { static: true }) srcInput!: EMMAInputComponent;
  @Output() close = new EventEmitter<void>();
  @Output() $insert = new EventEmitter<string>();
  @Input() loading = false;

  src = '';

  ngAfterViewInit() {
    if (this.srcInput) {
      this.srcInput.focus();
    }
  }

  onCloseButton() {
    this.close.emit();
  }

  onInsertImageButton() {
    if (this.src) {
      this.$insert.emit(this.src);
    }
    this.close.emit();
  }
}
